module.exports = __webpack_public_path__ + "static/media/me.8a1e7348.jpeg";